import * as React from "react";
import { connect } from "react-redux";

import { Text as TextComponent, TextProps } from "../../components/Text/Text";
import { getCoupon } from "../../reducers/methods";
import { withAction } from "../Actions/withActions";
import { StoreState } from "../../reducers";
import get from "lodash/get";

interface TextContainerProps extends TextProps {
  couponObject: ReturnType<typeof getCoupon>;
}

class Text extends React.PureComponent<TextContainerProps> {
  render() {
    // tslint:disable-next-line:no-any
    return (
      <TextComponent
        {...(this.props as any)}
        coupon={get(this.props.couponObject, "coupon", "")}
      />
    );
  }
}

const mapStateToProps = (state: StoreState) => ({
  couponObject: getCoupon(state),
});

export default withAction(connect(mapStateToProps, {})(Text));
